module.exports = __webpack_public_path__ + "static/media/sixth.07f90c62.gif";